import { $ } from '@/Engine/state';
import { visibleOffForModel } from '@/Engine/app';
import _ from 'lodash';
import { useStoreUI } from '@/Store/storeUI';
import { Vector3 } from 'three';
import { faceNodeNameRGB, frameNodeNameRGB } from '@/Constants/colors';

export async function onStoreUiUpdate() {
    if (!$.toolChest) return;
    let idActiveComponent: string | null = null;
    const state = useStoreUI().$state;
    if (!state.dndItem) return;
    idActiveComponent = crypto.randomUUID();
    const item = {
        id: idActiveComponent,
        prototypeId: state.dndItem,
        indexPositionY: 0,
        isLeft: false,
    };
    const part = $.toolChest.createPartItem(item);
    if (!part) return;
    const position = new Vector3(0, 0, 0);

    if (
        $.positionStartPointer &&
        !part.key.includes('separator') &&
        part.model.name !== 'set_niches_tc_1995' &&
        part.model.name !== 'table_hard_1000' &&
        part.model.name !== 'lateral_screen_ms'
    ) {
        position.y = $.positionStartPointer.y;
        if (part.key === 'accessory') position.x = $.positionStartPointer.x;
    }
    part.position = position;
    part._isLeft = item.isLeft;
    $.toolChest.addComponent(part);
    part.setColor(frameNodeNameRGB, $.toolChest.colorFrame);
    part.setColor(faceNodeNameRGB, $.toolChest.colorFace);
    part.select();
    visibleOffForModel(part.model);
    await $.toolChest?.replaceModel(part.model?.name);
}

export const onStoreUiUpdateHandlerThrottled = _.throttle(onStoreUiUpdate, 100);
